import { configureStore } from '@reduxjs/toolkit';

import featureToggleReducer, { FEATURE_SLICE_NAME } from '@/configuration/featureToggle/featureToggleSlice';
import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import assetTreeReducer from '@/features/app/assetTreeSlice';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        assetTree: assetTreeReducer,
        [FEATURE_SLICE_NAME]: featureToggleReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
